module.exports = __webpack_public_path__ + "static/media/online-support.35a716bb.jpg";